import Icon from '../components/Icon.vue'

Icon.register({
  'hand-pointer': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 240v96c0 3.1-0.4 6.2-1.1 9.2l-32 136c-4.3 18.1-20.4 30.8-38.9 30.8h-208c-11.2 0-25.7-7.4-32.3-16.5l-128-176c-13-17.9-9-42.9 8.8-55.9 17.9-13 42.9-9 55.9 8.8l31.6 43.5v-276c0-22.1 17.9-40 40-40s40 17.9 40 40v200h8v-40c0-22.1 17.9-40 40-40s40 17.9 40 40v40h8v-24c0-22.1 17.9-40 40-40s40 17.9 40 40v24h8c0-22.1 17.9-40 40-40s40 17.9 40 40zM192 320h-8v96h8v-96zM280 320h-8v96h8v-96zM368 320h-8v96h8v-96z'
      }
    ]
  }
})
